import { base64ToBlob } from "base64-blob"
import JSZip from "jszip"

const TKRISK_EXT = ".tkrisk"
const MODIFIED_DIR = "modified"

/**
 * Adds the locally modified graph to the export zip produced by the backend.
 *
 * The original entries (including the pristine tkrisk file) are left untouched - the
 * modified copy is added alongside them under `modified/{name}.tkrisk`, so it can't be
 * confused with the original. The name is taken from the tkrisk entry already present
 * in the zip, `fallbackName` is used when the zip has none.
 *
 * @param modifiedTkriskBase64 - graph blob as stored in IndexedDB (a data url)
 */
export const injectModifiedTkrisk = async (
  exportZip: ArrayBuffer,
  modifiedTkriskBase64: string,
  fallbackName: string,
): Promise<Blob> => {
  const zip = await JSZip.loadAsync(exportZip)
  const tkriskEntry = Object.keys(zip.files).find((name) => name.endsWith(TKRISK_EXT))
  const baseName = tkriskEntry ? tkriskEntry.slice(0, -TKRISK_EXT.length) : fallbackName

  const modifiedTkrisk = await base64ToBlob(modifiedTkriskBase64)
  zip.file(`${MODIFIED_DIR}/${baseName}${TKRISK_EXT}`, await modifiedTkrisk.arrayBuffer())

  return zip.generateAsync({ type: "blob" })
}
